module.exports = __webpack_public_path__ + "img/logo-letter-4.8bb7c06e.png";